import {
    ChipTransactionQueryParams,
    MyTransactionQueryParams,
    OrgChipQueryParams,
    OrgTransactionQueryParams,
} from 'src/api/mitarbeiterchip';
import { action } from 'src/store/actions';

/* Vending Orgs */
export const FETCH_VENDING_ORGS = 'FETCH_VENDING_ORGS';
export const REQUEST_VENDING_ORGS = 'REQUEST_VENDING_ORGS';
export const SUCCESS_VENDING_ORGS = 'SUCCESS_VENDING_ORGS';
export const FAILURE_VENDING_ORGS = 'FAILURE_VENDING_ORGS';

export const fetchVendingOrgs = () => action(FETCH_VENDING_ORGS);
export const requestVendingOrgs = () => action(REQUEST_VENDING_ORGS);
export const requestVendingOrgsSuccess = (response: any) => action(SUCCESS_VENDING_ORGS, { response });
export const requestVendingOrgsFailure = (error: any) => action(FAILURE_VENDING_ORGS, { error });

/* My Chips (chips of a customer) */
export const FETCH_MY_CHIPS = 'FETCH_MY_CHIPS';
export const REQUEST_MY_CHIPS = 'REQUEST_MY_CHIPS';
export const SUCCESS_MY_CHIPS = 'SUCCESS_MY_CHIPS';
export const FAILURE_MY_CHIPS = 'FAILURE_MY_CHIPS';

export const fetchMyChips = (customerId?: string) => action(FETCH_MY_CHIPS, { customerId });
export const requestMyChips = () => action(REQUEST_MY_CHIPS);
export const requestMyChipsSuccess = (response: any) => action(SUCCESS_MY_CHIPS, { response });
export const requestMyChipsFailure = (error: any) => action(FAILURE_MY_CHIPS, { error });

/* Customer Vending Memberships (admin: vending role/orgs of the viewed customer) */
export const FETCH_CUSTOMER_MEMBERSHIPS = 'FETCH_CUSTOMER_MEMBERSHIPS';
export const REQUEST_CUSTOMER_MEMBERSHIPS = 'REQUEST_CUSTOMER_MEMBERSHIPS';
export const SUCCESS_CUSTOMER_MEMBERSHIPS = 'SUCCESS_CUSTOMER_MEMBERSHIPS';
export const FAILURE_CUSTOMER_MEMBERSHIPS = 'FAILURE_CUSTOMER_MEMBERSHIPS';

export const fetchCustomerMemberships = (customerId?: string) => action(FETCH_CUSTOMER_MEMBERSHIPS, { customerId });
export const requestCustomerMemberships = () => action(REQUEST_CUSTOMER_MEMBERSHIPS);
export const requestCustomerMembershipsSuccess = (response: any) => action(SUCCESS_CUSTOMER_MEMBERSHIPS, { response });
export const requestCustomerMembershipsFailure = (error: any) => action(FAILURE_CUSTOMER_MEMBERSHIPS, { error });

/* Org Members (machine-scoped viewer access management) */
export const FETCH_ORG_MEMBERS = 'FETCH_ORG_MEMBERS';
export const REQUEST_ORG_MEMBERS = 'REQUEST_ORG_MEMBERS';
export const SUCCESS_ORG_MEMBERS = 'SUCCESS_ORG_MEMBERS';
export const FAILURE_ORG_MEMBERS = 'FAILURE_ORG_MEMBERS';

export const fetchOrgMembers = (orgId: string) => action(FETCH_ORG_MEMBERS, { orgId });
export const requestOrgMembers = () => action(REQUEST_ORG_MEMBERS);
export const requestOrgMembersSuccess = (response: any) => action(SUCCESS_ORG_MEMBERS, { response });
export const requestOrgMembersFailure = (error: any) => action(FAILURE_ORG_MEMBERS, { error });

/* Org Chips */
export const FETCH_ORG_CHIPS = 'FETCH_ORG_CHIPS';
export const REQUEST_ORG_CHIPS = 'REQUEST_ORG_CHIPS';
export const SUCCESS_ORG_CHIPS = 'SUCCESS_ORG_CHIPS';
export const FAILURE_ORG_CHIPS = 'FAILURE_ORG_CHIPS';

export const fetchOrgChips = (orgId: string, params?: OrgChipQueryParams) => action(FETCH_ORG_CHIPS, { orgId, params });
export const requestOrgChips = () => action(REQUEST_ORG_CHIPS);
export const requestOrgChipsSuccess = (response: any) => action(SUCCESS_ORG_CHIPS, { response });
export const requestOrgChipsFailure = (error: any) => action(FAILURE_ORG_CHIPS, { error });

/* Org Overview */
export const FETCH_ORG_OVERVIEW = 'FETCH_ORG_OVERVIEW';
export const REQUEST_ORG_OVERVIEW = 'REQUEST_ORG_OVERVIEW';
export const SUCCESS_ORG_OVERVIEW = 'SUCCESS_ORG_OVERVIEW';
export const FAILURE_ORG_OVERVIEW = 'FAILURE_ORG_OVERVIEW';

export const fetchOrgOverview = (orgId: string) => action(FETCH_ORG_OVERVIEW, { orgId });
export const requestOrgOverview = () => action(REQUEST_ORG_OVERVIEW);
export const requestOrgOverviewSuccess = (response: any) => action(SUCCESS_ORG_OVERVIEW, { response });
export const requestOrgOverviewFailure = (error: any) => action(FAILURE_ORG_OVERVIEW, { error });

/* Org Yearly (one row per month) */
export const FETCH_ORG_YEARLY = 'FETCH_ORG_YEARLY';
export const REQUEST_ORG_YEARLY = 'REQUEST_ORG_YEARLY';
export const SUCCESS_ORG_YEARLY = 'SUCCESS_ORG_YEARLY';
export const FAILURE_ORG_YEARLY = 'FAILURE_ORG_YEARLY';

export const fetchOrgYearly = (orgId: string, year: number) => action(FETCH_ORG_YEARLY, { orgId, year });
export const requestOrgYearly = () => action(REQUEST_ORG_YEARLY);
export const requestOrgYearlySuccess = (response: any) => action(SUCCESS_ORG_YEARLY, { response });
export const requestOrgYearlyFailure = (error: any) => action(FAILURE_ORG_YEARLY, { error });

/* Org Transactions (Einzelbezüge — global, filtered) */
export const FETCH_ORG_TRANSACTIONS = 'FETCH_ORG_TRANSACTIONS';
export const REQUEST_ORG_TRANSACTIONS = 'REQUEST_ORG_TRANSACTIONS';
export const SUCCESS_ORG_TRANSACTIONS = 'SUCCESS_ORG_TRANSACTIONS';
export const FAILURE_ORG_TRANSACTIONS = 'FAILURE_ORG_TRANSACTIONS';

export const fetchOrgTransactions = (orgId: string, params?: OrgTransactionQueryParams) =>
    action(FETCH_ORG_TRANSACTIONS, { orgId, params });
export const requestOrgTransactions = () => action(REQUEST_ORG_TRANSACTIONS);
export const requestOrgTransactionsSuccess = (response: any) => action(SUCCESS_ORG_TRANSACTIONS, { response });
export const requestOrgTransactionsFailure = (error: any) => action(FAILURE_ORG_TRANSACTIONS, { error });

/* Org Transactions CSV import (admin-only) */
export const IMPORT_ORG_TRANSACTIONS = 'IMPORT_ORG_TRANSACTIONS';

export const importOrgTransactions = (orgId: string, formData: FormData) =>
    action(IMPORT_ORG_TRANSACTIONS, { orgId, formData });

/* Org vends CSV import — machine-level cash sales (admin-only) */
export const IMPORT_ORG_VENDS = 'IMPORT_ORG_VENDS';

export const importOrgVends = (orgId: string, formData: FormData) => action(IMPORT_ORG_VENDS, { orgId, formData });

/* Org Chips CSV import (admin-only) */
export const IMPORT_ORG_CHIPS = 'IMPORT_ORG_CHIPS';

export const importOrgChips = (orgId: string, formData: FormData) => action(IMPORT_ORG_CHIPS, { orgId, formData });

/* Org Machines (filter options) */
export const FETCH_ORG_MACHINES = 'FETCH_ORG_MACHINES';
export const REQUEST_ORG_MACHINES = 'REQUEST_ORG_MACHINES';
export const SUCCESS_ORG_MACHINES = 'SUCCESS_ORG_MACHINES';
export const FAILURE_ORG_MACHINES = 'FAILURE_ORG_MACHINES';

export const fetchOrgMachines = (orgId: string) => action(FETCH_ORG_MACHINES, { orgId });
export const requestOrgMachines = () => action(REQUEST_ORG_MACHINES);
export const requestOrgMachinesSuccess = (response: any) => action(SUCCESS_ORG_MACHINES, { response });
export const requestOrgMachinesFailure = (error: any) => action(FAILURE_ORG_MACHINES, { error });

/* Org Persons (for the chip-reassignment picker) */
export const FETCH_ORG_PERSONS = 'FETCH_ORG_PERSONS';
export const REQUEST_ORG_PERSONS = 'REQUEST_ORG_PERSONS';
export const SUCCESS_ORG_PERSONS = 'SUCCESS_ORG_PERSONS';
export const FAILURE_ORG_PERSONS = 'FAILURE_ORG_PERSONS';

export const fetchOrgPersons = (orgId: string) => action(FETCH_ORG_PERSONS, { orgId });
export const requestOrgPersons = () => action(REQUEST_ORG_PERSONS);
export const requestOrgPersonsSuccess = (response: any) => action(SUCCESS_ORG_PERSONS, { response });
export const requestOrgPersonsFailure = (error: any) => action(FAILURE_ORG_PERSONS, { error });

/* Chip Detail */
export const FETCH_CHIP = 'FETCH_CHIP';
export const REQUEST_CHIP = 'REQUEST_CHIP';
export const SUCCESS_CHIP = 'SUCCESS_CHIP';
export const FAILURE_CHIP = 'FAILURE_CHIP';

export const fetchChip = (chipId: string) => action(FETCH_CHIP, { chipId });
export const requestChip = () => action(REQUEST_CHIP);
export const requestChipSuccess = (response: any) => action(SUCCESS_CHIP, { response });
export const requestChipFailure = (error: any) => action(FAILURE_CHIP, { error });

/* Chip Transactions */
export const FETCH_CHIP_TRANSACTIONS = 'FETCH_CHIP_TRANSACTIONS';
export const REQUEST_CHIP_TRANSACTIONS = 'REQUEST_CHIP_TRANSACTIONS';
export const SUCCESS_CHIP_TRANSACTIONS = 'SUCCESS_CHIP_TRANSACTIONS';
export const FAILURE_CHIP_TRANSACTIONS = 'FAILURE_CHIP_TRANSACTIONS';

export const fetchChipTransactions = (chipId: string, params?: ChipTransactionQueryParams) =>
    action(FETCH_CHIP_TRANSACTIONS, { chipId, params });
export const requestChipTransactions = () => action(REQUEST_CHIP_TRANSACTIONS);
export const requestChipTransactionsSuccess = (response: any) => action(SUCCESS_CHIP_TRANSACTIONS, { response });
export const requestChipTransactionsFailure = (error: any) => action(FAILURE_CHIP_TRANSACTIONS, { error });

/* Chip Yearly (per-chip monthly overview) */
export const FETCH_CHIP_YEARLY = 'FETCH_CHIP_YEARLY';
export const REQUEST_CHIP_YEARLY = 'REQUEST_CHIP_YEARLY';
export const SUCCESS_CHIP_YEARLY = 'SUCCESS_CHIP_YEARLY';
export const FAILURE_CHIP_YEARLY = 'FAILURE_CHIP_YEARLY';

export const fetchChipYearly = (chipId: string, year: number) => action(FETCH_CHIP_YEARLY, { chipId, year });
export const requestChipYearly = () => action(REQUEST_CHIP_YEARLY);
export const requestChipYearlySuccess = (response: any) => action(SUCCESS_CHIP_YEARLY, { response });
export const requestChipYearlyFailure = (error: any) => action(FAILURE_CHIP_YEARLY, { error });

/* Chip Machines (filter options) */
export const FETCH_CHIP_MACHINES = 'FETCH_CHIP_MACHINES';
export const REQUEST_CHIP_MACHINES = 'REQUEST_CHIP_MACHINES';
export const SUCCESS_CHIP_MACHINES = 'SUCCESS_CHIP_MACHINES';
export const FAILURE_CHIP_MACHINES = 'FAILURE_CHIP_MACHINES';

export const fetchChipMachines = (chipId: string) => action(FETCH_CHIP_MACHINES, { chipId });
export const requestChipMachines = () => action(REQUEST_CHIP_MACHINES);
export const requestChipMachinesSuccess = (response: any) => action(SUCCESS_CHIP_MACHINES, { response });
export const requestChipMachinesFailure = (error: any) => action(FAILURE_CHIP_MACHINES, { error });

/* My Transactions (caller-scoped Einzelbezüge — all or one own chip, filtered) */
export const FETCH_MY_TRANSACTIONS = 'FETCH_MY_TRANSACTIONS';
export const REQUEST_MY_TRANSACTIONS = 'REQUEST_MY_TRANSACTIONS';
export const SUCCESS_MY_TRANSACTIONS = 'SUCCESS_MY_TRANSACTIONS';
export const FAILURE_MY_TRANSACTIONS = 'FAILURE_MY_TRANSACTIONS';

export const fetchMyTransactions = (params?: MyTransactionQueryParams) => action(FETCH_MY_TRANSACTIONS, { params });
export const requestMyTransactions = () => action(REQUEST_MY_TRANSACTIONS);
export const requestMyTransactionsSuccess = (response: any) => action(SUCCESS_MY_TRANSACTIONS, { response });
export const requestMyTransactionsFailure = (error: any) => action(FAILURE_MY_TRANSACTIONS, { error });

/* My Machines (filter options across all own chips) */
export const FETCH_MY_MACHINES = 'FETCH_MY_MACHINES';
export const REQUEST_MY_MACHINES = 'REQUEST_MY_MACHINES';
export const SUCCESS_MY_MACHINES = 'SUCCESS_MY_MACHINES';
export const FAILURE_MY_MACHINES = 'FAILURE_MY_MACHINES';

export const fetchMyMachines = () => action(FETCH_MY_MACHINES);
export const requestMyMachines = () => action(REQUEST_MY_MACHINES);
export const requestMyMachinesSuccess = (response: any) => action(SUCCESS_MY_MACHINES, { response });
export const requestMyMachinesFailure = (error: any) => action(FAILURE_MY_MACHINES, { error });

/* My Yearly (caller-scoped monthly overview — all or one own chip) */
export const FETCH_MY_YEARLY = 'FETCH_MY_YEARLY';
export const REQUEST_MY_YEARLY = 'REQUEST_MY_YEARLY';
export const SUCCESS_MY_YEARLY = 'SUCCESS_MY_YEARLY';
export const FAILURE_MY_YEARLY = 'FAILURE_MY_YEARLY';

export const fetchMyYearly = (year: number, chipId?: string) => action(FETCH_MY_YEARLY, { year, chipId });
export const requestMyYearly = () => action(REQUEST_MY_YEARLY);
export const requestMyYearlySuccess = (response: any) => action(SUCCESS_MY_YEARLY, { response });
export const requestMyYearlyFailure = (error: any) => action(FAILURE_MY_YEARLY, { error });

/* Set/clear reminder */
export const SET_CHIP_REMINDER = 'SET_CHIP_REMINDER';

export const setChipReminder = (
    chipId: string,
    data: { reminderThreshold: number | null; reminderEmail: string | null }
) => action(SET_CHIP_REMINDER, { chipId, data });

/* Chip History */
export const FETCH_CHIP_HISTORY = 'FETCH_CHIP_HISTORY';
export const REQUEST_CHIP_HISTORY = 'REQUEST_CHIP_HISTORY';
export const SUCCESS_CHIP_HISTORY = 'SUCCESS_CHIP_HISTORY';
export const FAILURE_CHIP_HISTORY = 'FAILURE_CHIP_HISTORY';

export const fetchChipHistory = (chipId: string) => action(FETCH_CHIP_HISTORY, { chipId });
export const requestChipHistory = () => action(REQUEST_CHIP_HISTORY);
export const requestChipHistorySuccess = (response: any) => action(SUCCESS_CHIP_HISTORY, { response });
export const requestChipHistoryFailure = (error: any) => action(FAILURE_CHIP_HISTORY, { error });

/* Resend registration email */
export const RESEND_CHIP_REGISTRATION = 'RESEND_CHIP_REGISTRATION';

export const resendChipRegistration = (chipId: string) => action(RESEND_CHIP_REGISTRATION, { chipId });

/* Request a chip type change (Umstellen) — emails the back office, no DB change */
export const REQUEST_CHIP_TYPE_CHANGE = 'REQUEST_CHIP_TYPE_CHANGE';

export const requestChipTypeChange = (chipId: string) => action(REQUEST_CHIP_TYPE_CHANGE, { chipId });

/* Vending Org Mutations */
export const CREATE_VENDING_ORG = 'CREATE_VENDING_ORG';

export const createVendingOrg = (name: string, ownerCustomerId: number) =>
    action(CREATE_VENDING_ORG, { data: { name, ownerCustomerId } });

/* Org Member Mutations (machine-scoped viewer access) */
export const ADD_ORG_MEMBER = 'ADD_ORG_MEMBER';
export const UPDATE_ORG_MEMBER = 'UPDATE_ORG_MEMBER';
export const REMOVE_ORG_MEMBER = 'REMOVE_ORG_MEMBER';

export const CREATE_ORG_MACHINE = 'CREATE_ORG_MACHINE';
export const createOrgMachine = (orgId: string, name: string) => action(CREATE_ORG_MACHINE, { orgId, data: { name } });

export const addOrgMember = (orgId: string, data: unknown) => action(ADD_ORG_MEMBER, { orgId, data });
export const updateOrgMember = (orgId: string, customerId: number, data: unknown) =>
    action(UPDATE_ORG_MEMBER, { orgId, customerId, data });
export const removeOrgMember = (orgId: string, customerId: number) => action(REMOVE_ORG_MEMBER, { orgId, customerId });

/* Chip Mutations (create / link / update / topup) */
export const CREATE_CHIP = 'CREATE_CHIP';
export const CORRECT_CHIP = 'CORRECT_CHIP';
export const LINK_CHIP = 'LINK_CHIP';
export const ASSIGN_CHIP = 'ASSIGN_CHIP';
export const UPDATE_CHIP = 'UPDATE_CHIP';
export const TOPUP_CHIP = 'TOPUP_CHIP';
export const REQUEST_CHIP_MUTATION = 'REQUEST_CHIP_MUTATION';
export const SUCCESS_CHIP_MUTATION = 'SUCCESS_CHIP_MUTATION';
export const FAILURE_CHIP_MUTATION = 'FAILURE_CHIP_MUTATION';

export const createChip = (orgId: string, data: unknown) => action(CREATE_CHIP, { orgId, data });
export const correctChip = (orgId: string, data: { serialNumber: string; cardNumber: string }) =>
    action(CORRECT_CHIP, { orgId, data });
export const linkChip = (chipId: string, data: unknown, orgId?: string) => action(LINK_CHIP, { chipId, data, orgId });
export const assignChip = (chipId: string, data: unknown, orgId?: string) =>
    action(ASSIGN_CHIP, { chipId, data, orgId });
export const updateChip = (chipId: string, data: unknown, orgId?: string) =>
    action(UPDATE_CHIP, { chipId, data, orgId });
export const topUpChip = (chipId: string, data: unknown) => action(TOPUP_CHIP, { chipId, data });
export const requestChipMutation = () => action(REQUEST_CHIP_MUTATION);
export const requestChipMutationSuccess = (response: any) => action(SUCCESS_CHIP_MUTATION, { response });
export const requestChipMutationFailure = (error: any) => action(FAILURE_CHIP_MUTATION, { error });

/* Settlement Config (Abrechnung — org fees) */
export const FETCH_SETTLEMENT_CONFIG = 'FETCH_SETTLEMENT_CONFIG';
export const REQUEST_SETTLEMENT_CONFIG = 'REQUEST_SETTLEMENT_CONFIG';
export const SUCCESS_SETTLEMENT_CONFIG = 'SUCCESS_SETTLEMENT_CONFIG';
export const FAILURE_SETTLEMENT_CONFIG = 'FAILURE_SETTLEMENT_CONFIG';

export const fetchSettlementConfig = (orgId: string) => action(FETCH_SETTLEMENT_CONFIG, { orgId });
export const requestSettlementConfig = () => action(REQUEST_SETTLEMENT_CONFIG);
export const requestSettlementConfigSuccess = (response: any) => action(SUCCESS_SETTLEMENT_CONFIG, { response });
export const requestSettlementConfigFailure = (error: any) => action(FAILURE_SETTLEMENT_CONFIG, { error });

export const UPDATE_SETTLEMENT_CONFIG = 'UPDATE_SETTLEMENT_CONFIG';

export const updateSettlementConfig = (orgId: string, data: unknown) =>
    action(UPDATE_SETTLEMENT_CONFIG, { orgId, data });

/* Settlement Parties (external machine owners) */
export const FETCH_SETTLEMENT_PARTIES = 'FETCH_SETTLEMENT_PARTIES';
export const REQUEST_SETTLEMENT_PARTIES = 'REQUEST_SETTLEMENT_PARTIES';
export const SUCCESS_SETTLEMENT_PARTIES = 'SUCCESS_SETTLEMENT_PARTIES';
export const FAILURE_SETTLEMENT_PARTIES = 'FAILURE_SETTLEMENT_PARTIES';

export const fetchSettlementParties = (orgId: string) => action(FETCH_SETTLEMENT_PARTIES, { orgId });
export const requestSettlementParties = () => action(REQUEST_SETTLEMENT_PARTIES);
export const requestSettlementPartiesSuccess = (response: any) => action(SUCCESS_SETTLEMENT_PARTIES, { response });
export const requestSettlementPartiesFailure = (error: any) => action(FAILURE_SETTLEMENT_PARTIES, { error });

export const CREATE_SETTLEMENT_PARTY = 'CREATE_SETTLEMENT_PARTY';
export const UPDATE_SETTLEMENT_PARTY = 'UPDATE_SETTLEMENT_PARTY';
export const DELETE_SETTLEMENT_PARTY = 'DELETE_SETTLEMENT_PARTY';

export const createSettlementParty = (orgId: string, data: unknown) => action(CREATE_SETTLEMENT_PARTY, { orgId, data });
export const updateSettlementParty = (orgId: string, partyId: string, data: unknown) =>
    action(UPDATE_SETTLEMENT_PARTY, { orgId, partyId, data });
export const deleteSettlementParty = (orgId: string, partyId: string) =>
    action(DELETE_SETTLEMENT_PARTY, { orgId, partyId });

/* Machine Settlement (ownership / operator per machine) */
export const UPDATE_MACHINE_SETTLEMENT = 'UPDATE_MACHINE_SETTLEMENT';

export const updateMachineSettlement = (orgId: string, machineId: string, data: unknown) =>
    action(UPDATE_MACHINE_SETTLEMENT, { orgId, machineId, data });

/* Product Billing (product name → article mapping) */
export const FETCH_PRODUCT_BILLING = 'FETCH_PRODUCT_BILLING';
export const REQUEST_PRODUCT_BILLING = 'REQUEST_PRODUCT_BILLING';
export const SUCCESS_PRODUCT_BILLING = 'SUCCESS_PRODUCT_BILLING';
export const FAILURE_PRODUCT_BILLING = 'FAILURE_PRODUCT_BILLING';

export const fetchProductBilling = (orgId: string) => action(FETCH_PRODUCT_BILLING, { orgId });
export const requestProductBilling = () => action(REQUEST_PRODUCT_BILLING);
export const requestProductBillingSuccess = (response: any) => action(SUCCESS_PRODUCT_BILLING, { response });
export const requestProductBillingFailure = (error: any) => action(FAILURE_PRODUCT_BILLING, { error });

export const REPLACE_PRODUCT_BILLING = 'REPLACE_PRODUCT_BILLING';

export const replaceProductBilling = (orgId: string, data: unknown) => action(REPLACE_PRODUCT_BILLING, { orgId, data });

/* Unmapped Products (purchased product names without billing mapping) */
export const FETCH_UNMAPPED_PRODUCTS = 'FETCH_UNMAPPED_PRODUCTS';
export const REQUEST_UNMAPPED_PRODUCTS = 'REQUEST_UNMAPPED_PRODUCTS';
export const SUCCESS_UNMAPPED_PRODUCTS = 'SUCCESS_UNMAPPED_PRODUCTS';
export const FAILURE_UNMAPPED_PRODUCTS = 'FAILURE_UNMAPPED_PRODUCTS';

export const fetchUnmappedProducts = (orgId: string) => action(FETCH_UNMAPPED_PRODUCTS, { orgId });
export const requestUnmappedProducts = () => action(REQUEST_UNMAPPED_PRODUCTS);
export const requestUnmappedProductsSuccess = (response: any) => action(SUCCESS_UNMAPPED_PRODUCTS, { response });
export const requestUnmappedProductsFailure = (error: any) => action(FAILURE_UNMAPPED_PRODUCTS, { error });
